export var OrdersMapper = function (response) {
    return response;
};
export var OrderListMapper = function (response) {
    return response;
};
export var ClientBankMapper = function (response) {
    return response;
};
export var EmpPartnerDetailsMapper = function (response) {
    return response;
};
export var DocsMapper = function (response) {
    return response;
};
export var OrderDetailsMapper = function (response) {
    return response;
};
export var ValidateFormMapper = function (response) {
    return response;
};
export var OrderDeclarationsMapper = function (response) {
    return response;
};
export var MultidocsMapper = function (response) {
    return response;
};
